<template>
  <div>
    <slot/>
  </div>
</template>

<script>
import Vue from "vue";

// This is only used in reporting
// https://markus.oberlehner.net/blog/dynamic-vue-layout-components/

export default {
  name: "PlainLayout",
  metaInfo() {
        return {
          theContent: this.generateContent,
          meta: [
            { name: "viewport", content: this.generateContent }
          ]
         }
  },
  created() {
  },
  computed: {
    generateContent() {
      return "width=900, maximum-scale=5, user-scalable=1";
    },
  },
  data: function () {
    return {
    };
  },
};
</script>
